// 采用按需加载时  此全局css样式，需要删除
import '@nutui/nutui/dist/nutui.scss';
import 'vant/lib/index.css'; // 引入 vant 样式

import App from './App.vue'
import Http from './http/http'
import NutUI from "@nutui/nutui";
// Remove the local Toast import
// import Toast from '@/components/layer/Toast.vue'
import Vue from 'vue'
import router from './router'
import { Toast, Loading } from 'vant'; // 引入 vant 的 Toast 和 Loading 组件

NutUI.install(Vue);
Vue.use(router);
Vue.use(Toast);
Vue.use(Loading); // 全局注册 Loading 组件

Vue.config.productionTip = false
Vue.prototype.$Http = Http

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

